import frLocale from 'element-ui/lib/locale/lang/fr' //引入element语言包
const fr = {
    Login: {
        ToLogin: 'Se connecter',
        PhoneLogin: 'Numéro de téléphone mobile login',
        EmailLogin: 'Mailbox login',
        PhonePlaceholder: 'Veuillez entrer le numéro de téléphone portable',
        EmailPlaceholder: 'Enter email',
        Code: 'Code de vérification',
        and: 'Et',
        BeforeText: 'Créer un compte tout en acceptant et en respectant en votre nom',
        UserAgreement: 'Accord utilisateur',
        privacy: 'Politique de confidentialité',
        errorMessage: 'Erreur de code de vérification',
        readTitle: "Lire et accepter l'accord suivant",
        readBefore: "Pour garantir la sécurité de vos informations personnelles, veuillez d'abord lire et accepter",
        cancel: 'Annulation',
        agree: 'Accepter et continuer',
        error1: 'Veuillez entrer une adresse Email valide',
        error2: 'Veuillez entrer le bon numéro de téléphone portable',
        error3: 'Veuillez entrer le Code de vérification',
        success: 'Connexion réussie'
    },
    ...frLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default fr;
